import TrainingConstants from "../constants/training-constants";


const initState = {
	courseLibrary: {
		filters: {
			page: 1,
			job_number: "",
			real_name: "",
			training_type: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	internalCourse: {
		filters: {
			page: 1,
			job_number: "",
			real_name: "",
			training_courses_type_name: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	externalCourse: {
		filters: {
			page: 1,
			job_number: "",
			real_name: "",
			training_type: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	newcomerTraining: {

	}
}

export default function training (state = initState, action) {
	switch (action.type) {
		// course-library
		case TrainingConstants.ActionTypes.CHANGETRAININGCOURSE:
			return {
				...state,
				courseLibrary: {
					...state.courseLibrary,
					filters: {
						...state.courseLibrary.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.courseLibrary.loadCounter + action.payload.counter
				}
			}
		case TrainingConstants.ActionTypes.SELECTTRAININGCOURSE:
			return {
				...state,
				courseLibrary: {
					...state.courseLibrary,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		// internal-course
		case TrainingConstants.ActionTypes.CHANGEINTERNALCOURSE:
			return {
				...state,
				internalCourse: {
					...state.internalCourse,
					filters: {
						...state.internalCourse.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.internalCourse.loadCounter + action.payload.counter
				}
			}
		case TrainingConstants.ActionTypes.SELECTINTERNALCOURSE:
			return {
				...state,
				internalCourse: {
					...state.internalCourse,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case TrainingConstants.ActionTypes.UPDATEINTERNALCOURSE:
			let copyInternalUpdateData = state.internalCourse.data.Data;
			copyInternalUpdateData[action.payload.index] = action.payload.value;
			return {
				...state,
				internalCourse: {
					...state.internalCourse,
					data: {
						...state.internalCourse.data,
						// Data: copyInternalUpdateData
						Data: [
							...state.internalCourse.data.Data.slice(0, action.payload.index),
							action.payload.value,
							...state.internalCourse.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		// external-course
		case TrainingConstants.ActionTypes.CHANGEEXTERNALCOURSE:
			return {
				...state,
				externalCourse: {
					...state.externalCourse,
					filters: {
						...state.externalCourse.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.externalCourse.loadCounter + action.payload.counter
				}
			}
		case TrainingConstants.ActionTypes.SELECTEXTERNALCOURSE:
			return {
				...state,
				externalCourse: {
					...state.externalCourse,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case TrainingConstants.ActionTypes.UPDATEEXTERNALCOURSE:
			let copyExternalUpdateData = state.externalCourse.data.Data;
			copyExternalUpdateData[action.payload.index] = action.payload.value;
			return {
				...state,
				externalCourse: {
					...state.externalCourse,
					data: {
						...state.externalCourse.data,
						Data: copyExternalUpdateData
					}					
				}
			}
		// newcomer-training

		default :
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/training-reducer.js